<div class="d-flex flex-column fixed-size">
    <mat-dialog-content class="mx-4 mat-dialog-content-height">
        <div *ngFor="let item of canShow()" class="d-flex flex-row">
            <mat-checkbox (change)="selectPlace(item)" [checked]="checkPlace(item)" class="checklist-leaf-node"
                          color="primary">{{item.name}}</mat-checkbox>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions class="m-0 d-flex flex-row justify-content-center">
        <button (click)="onNoClick()" class="mx-4 col-4 btn btn-secondary" mat-button>Annuler</button>
        <button (click)="onValidation()" class="mx-4 col-4 btn btn-primary" mat-button>Valider</button>
    </mat-dialog-actions>
</div>

